import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * 🧱 Estructura base de una notificación individual
 */
export interface NotificationPayload {
  id: string;
  title: string;
  message: string;
  type?: string; // Tipo funcional (ej. STOCK_LOW, SALE, SECURITY, etc.)
  level?:
    | "INFO"
    | "SUCCESS"
    | "WARNING"
    | "ERROR"
    | "CRITICAL"
    | "AUDIT"
    | "SECURITY"
    | "FINANCIAL"
    | "STOCK"
    | "SALE"
    | "PURCHASE"
    | "INVENTORY"
    | "INTEGRATION"
    | "SYNC"
    | "API"
    | "NETWORK"
    | "SUPPORT"
    | "MAINTENANCE"
    | "SYSTEM_UPDATE"
    | "BACKUP"
    | "PERFORMANCE"
    | "USER_ACTIVITY"
    | "USER_FEEDBACK"
    | "ANNOUNCEMENT"
    | "TRAINING"
    | "DATABASE"
    | "SERVICE"
    | "SCHEDULER"
    | "HARDWARE"
    | "PRINTER"
    | "DEVICE"
    | "CLOUD"
    | "ALERT"
    | "UNKNOWN";
  createdAt?: string;
  isRead?: boolean;
}

/**
 * 🎯 Estado del modal de notificación
 */
interface NotificationModalState {
  isOpen: boolean;
  notification: NotificationPayload | null;
}

const initialState: NotificationModalState = {
  isOpen: false,
  notification: null,
};

/**
 * 🧩 Slice de Redux — controla apertura, cierre y datos de la notificación actual
 */
export const notificationModalSlice = createSlice({
  name: "notificationModal",
  initialState,
  reducers: {
    showNotificationModal: (state, action: PayloadAction<NotificationPayload>) => {
      state.isOpen = true;
      state.notification = action.payload;
    },
    hideNotificationModal: (state) => {
      state.isOpen = false;
      state.notification = null;
    },
  },
});

export const { showNotificationModal, hideNotificationModal } =
  notificationModalSlice.actions;

export default notificationModalSlice.reducer;
